import { ActionItemStatus } from '@uplift/api';
import { useProviderTrainingsQuery } from '@uplift/queries';

import { getAggregateGateStatus } from './helpers';

export const useRequiredTrainingsGateStatus = (providerId: string): { status: ActionItemStatus; isLoading: boolean } => {
  const { data, isLoading } = useProviderTrainingsQuery(providerId, { requiredOnly: true });

  return {
    status: getAggregateGateStatus(data?.trainings ?? []),
    isLoading,
  };
};
